<template>
    <svg
      :class="svgClass"
      :style="{
        width: size + 'px',
        height: size + 'px',
        color: color,
      }"
      aria-hidden="true"
    >
      <use :xlink:href="`#icon-${name}`" />
    </svg>
  </template>
  
  <script>

  export default {
     name: "SvgIcon",
     props: {
        name: { type: String, required: true },
        className: { type: String, default: "" },
        size: { type: Number, default: 16 },
        color: { type: String, default: "" },
     },
     computed: {
        svgClass: function () {
            // `this` 指向 vm 实例
            if (this.className) {
                return "svg-icon " + this.className;
            } else {
                return "svg-icon";
            }
        }
     }
  }
  
  </script>
  <style scoped lang="scss">
  .svg-icon {
    width: 1em;
    height: 1em;
    fill: currentColor;
    overflow: hidden;
    color: var(--color);
  }
  </style>
  